import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import AppWrapper from '../app_wrapper';
import PressMobile from '../components_mobile/pages/Press';
import PressDesktop from '../components_desktop/pages/Press';
import { apiGet } from '../modules/api';
import metadata from '../helpers/metadataHelper';

const PressComponent = props => (
  <Fragment>
    <AppWrapper
      desktopComp={<PressDesktop {...props} />}
      mobileComp={<PressMobile {...props} />}
      metadata={metadata.press}
    />
  </Fragment>
);

PressComponent.getInitialProps = ({ store, req, res }) => store.dispatch(apiGet('api/home', req, res));

const mapStateToProps = () => ({});

const Press = connect(mapStateToProps)(PressComponent);
export default Press;
